export const APP_INFO = {
  appName: "TOPUP CONNECT",
  companyName: "TOPUP CONNECT",
  address:
    "Topup Connect, Barasat - 1, Kathuria, Malikapur, Duttapukur, Barasat, North 24 Parganas, West Bengal - 700126",
  phone: "+91 7890067005",
  whatsappNumber: "+91 7890067005",
  whatsappNumberRedirect: "917890067005",
  email: "support@topupconnect.in",
  grievanceEmail: "support@topupconnect.in",
  domainName: "topupconnect.in",
  websiteUrl: "https://topupconnect.in",
  appDownloadUrl:
    "https://play.google.com/store/apps/details?id=com.topupconnect.topupconnectindia",
  facebookUrl: "https://www.facebook.com/topupconnectapp",
  instagramUrl: "https://www.instagram.com/topupconnectapp",
  whatsappUrl: "https://www.whatsapp.com/channel/0029VbBPQDd9MF8tbTtlpg0V",
  youtubeUrl: "https://www.youtube.com/topupconnectapp",
  telegramUrl: "https://t.me/topupconnectapp",
};
